// @flow
import React from 'react';
import i18next from 'i18next';

const outerStyle = {
  minHeight: 'min(32vh, 280px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '24px',
  textAlign: 'center',
};

const compactOuterStyle = {
  minHeight: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px 16px',
  textAlign: 'center',
};

const innerStyle = {
  background: 'transparent',
  border: 'none',
  borderRadius: 0,
  padding: 0,
  color: '#1f2937',
  fontSize: '14px',
  fontWeight: 600,
  letterSpacing: '0.2px',
  boxShadow: 'none',
};

type Props = {
  minHeight?: string,
  compact?: boolean,
};

const PageLoadingFallback = ({ minHeight, compact }: Props) => {
  let outer;
  if (compact) {
    outer = compactOuterStyle;
  } else if (minHeight != null) {
    outer = { ...outerStyle, minHeight };
  } else {
    outer = outerStyle;
  }
  return (
    <div style={outer}>
      <div style={innerStyle}>{i18next.t('sentences:loading')}</div>
    </div>
  );
};

export default PageLoadingFallback;
